import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "关键词"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "keyword", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "searchForm.keyword"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "范围（月）"
    }
  }, [_c("el-input-number", {
    attrs: {
      min: 1,
      max: 300
    },
    on: {
      change: _vm.changeMonth
    },
    model: {
      value: _vm.searchForm.month,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "month", $$v);
      },
      expression: "searchForm.month"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "发送人",
      width: "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$user;
        return [_c("wlc-image", {
          attrs: {
            src: (_scope$row$user = scope.row.user) === null || _scope$row$user === void 0 ? void 0 : _scope$row$user.avatar,
            width: "60",
            to: "/user/list?phone=".concat(scope.row.user.phone),
            compression: true
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.name",
      label: "发送人名称",
      width: "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.occupation",
      label: "发送人职业",
      width: "100px"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "msg",
      label: "消息内容"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.objectName === "RC:TxtMsg" ? _c("div", {
          domProps: {
            innerHTML: _vm._s(scope.row.msg)
          }
        }) : _vm._e(), scope.row.objectName === "system" ? _c("div", {
          domProps: {
            innerHTML: _vm._s(scope.row.msg)
          }
        }) : _vm._e(), scope.row.objectName === "RC:HQVCMsg" ? _c("div", {
          domProps: {
            innerHTML: _vm._s(scope.row.msg)
          }
        }) : _vm._e(), scope.row.objectName === "RC:LBSMsg" ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("位置消息")]) : _vm._e(), scope.row.objectName == "RC:ImgMsg" ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("图片消息")]) : _vm._e(), scope.row.objectName == "RC:SightMsg" ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("视频消息")]) : _vm._e(), scope.row.objectName == "RC:HQVCMsg" ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("语音消息")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "other.name",
      label: "接收人名称",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var otherUserInfo = _ref2.row.otherUserInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: otherUserInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "聊天时间"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.goChatRecord(scope.row);
            }
          }
        }, [_vm._v("查看聊天记录")]), _c("el-button", {
          staticClass: "d2-ml-0",
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.setImConversationStatus(scope.row, 1);
            }
          }
        }, [_vm._v("标记为已处理")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };